/**
 * Created by yniran on 12/11/14.
 */

define(function (require) {

    var $ = require("jquery"),
        _ = require("underscore"),
        LE = require("app"),
        LEResourceResolver = require("leResourceResolver"),
        DomUtilities = require("infra-util/DomUtilities"),
        logger = require("logger").getLogger("LivepersonChatApi"),
        _isInitialized = false,
        _initDfrd = $.Deferred();

    function isInitialized() {
        return _isInitialized;
    }

    function addInitializer(callback) {
        _initDfrd = _initDfrd || $.Deferred();
        _initDfrd.then(callback);
    }

    function _init() {

        var chatApiUrl = LEResourceResolver.getUrl(LEResourceResolver.apiResources.AppServer.ChatApi);
        var surveyLogicUrl = LEResourceResolver.getUrl(LEResourceResolver.apiResources.AppServer.SurveyLogic);

        var initSetter = _.after(2, _setInitialized);
        logger.debug("about to load script tag for chat api from: " + chatApiUrl, "LivepersonChatApi._init");
        DomUtilities.addScriptTag(chatApiUrl, initSetter);

        logger.debug("about to load script tag for survey logic api from: " + surveyLogicUrl, "LivepersonChatApi._init");
        DomUtilities.addScriptTag(surveyLogicUrl, initSetter);
    }

    function _setInitialized() {

        logger.debug("setting LP API State to initialized", "LivepersonChatApi._setInitialized");
        _isInitialized = true;

        if (_initDfrd) {
            _initDfrd.resolve();
        }
    }

    _init();

    return {
        isInitialized: isInitialized,
        addInitializer: addInitializer
    };
});
